import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

export class NavigationEvent {
    constructor(
        public title: string,
        public param?: string,
        public returnBack?: boolean,
        public backUrl?: string,
        public backShowOnMobile?: boolean
    ) {}
}

export const navigationTitle: BehaviorSubject<NavigationEvent> = new BehaviorSubject({
    title: '',
    param: '',
    returnBack: false,
    backUrl: '',
    showOnMobile: false,
});

@Injectable({
    providedIn: 'root',
})
export class LayoutService implements OnDestroy {
    private _mobile: Subscription;
    private _mobileForDialog: Subscription;
    private _change = new BehaviorSubject<boolean>(false);
    private _changeForDialog = new BehaviorSubject<boolean>(false);
    mobile = signal<boolean>(false);
    mobileModeForDialog = signal<boolean>(false);
    contentStarted = signal<boolean>(false);
    constructor(private _breakpointObserver: BreakpointObserver) {
        this._mobile = this._breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Handset, Breakpoints.TabletPortrait])
            .subscribe({
                next: result => {
                    this.mobile.set(result.matches);
                    this._change.next(this.mobile());
                },
            });

        this.mobile.set(
            this._breakpointObserver.isMatched([
                Breakpoints.XSmall,
                Breakpoints.Small,
                Breakpoints.Handset,
                Breakpoints.TabletPortrait,
            ])
        );
        this._mobileForDialog = this._breakpointObserver
            .observe([
                Breakpoints.XSmall,
                Breakpoints.Small,
                Breakpoints.Handset,
                Breakpoints.Tablet,
                Breakpoints.TabletPortrait,
            ])
            .subscribe(result => {
                this.mobileModeForDialog.set(result.matches);
                this._changeForDialog.next(this.mobileModeForDialog());
            });

        this.mobileModeForDialog.set(
            this._breakpointObserver.isMatched([
                Breakpoints.XSmall,
                Breakpoints.Small,
                Breakpoints.Handset,
                Breakpoints.Tablet,
            ])
        );
    }

    get change() {
        return this._change;
    }

    get changeForDialog() {
        return this._changeForDialog;
    }

    ngOnDestroy() {
        this._mobile.unsubscribe();
        this._mobileForDialog.unsubscribe();
        this.contentStarted.set(false);
    }
}
